<template>
    <div>
        <v-card>

            <v-card-text>
                <v-text-field v-model="fm.email" label="Admin user email"></v-text-field>
                <v-row class="mt-n8">
                    <v-col>
                <v-switch v-model="fm.isAdmin" label="Admin"></v-switch>

                    </v-col>
                    <v-col>
                         <v-switch v-model="fm.isSupper" label="Super Admin"></v-switch>

                    </v-col>
                </v-row>
            </v-card-text>
             <v-card-actions>
                <div class="flex-grow-1"> </div>
                <v-btn success @click="addNewAdmin">Add User</v-btn>
            </v-card-actions>
           
        </v-card>
            <v-list color="#fafafa">
                <v-subheader>Admin users</v-subheader>
                <v-list-item v-for="x in admins" :key="x.email">
                   <v-list-item-content>
                      <v-list-item-title>{{x.email}}</v-list-item-title>
                      <v-list-item-subtitle>
                          <v-chip small :color="x.isAdmin?'green':'grey'" @click="setAdmin(x)">Is Admin</v-chip> &nbsp;
                          <v-chip small :color="x.isSupper?'green':'grey'" @click="setSuperAdmin(x)">Is Super Admin</v-chip>
                      </v-list-item-subtitle>
                   </v-list-item-content>
                    <v-list-item-action> <v-btn @click="removeAdmin(x)" icon><v-icon>delete</v-icon> </v-btn> </v-list-item-action>
                </v-list-item>
            </v-list>
    </div>
</template>
<script>
 import firebase from 'firebase/app';
 import fb from '../store/firebase.js';
export default {
    data(){
        return {
            admins:[],
            fm:{
                email:null,
                isAdmin:false,
                isSupper:false
            }
        }
    },
    methods:{
        addNewAdmin(){
            
            this.$store.dispatch("addAdmin", 
            {email: this.fm.email, 
            hasAccount:false,
            isAdmin: this.fm.isAdmin,
            isSupper: this.fm.isSupper});
        },
        removeAdmin(item){
          
           this.$store.dispatch("removeAdmin", item);
        },
        setAdmin(itm){
            itm.isAdmin = !itm.isAdmin
            console.log(itm, this.$firestoreRefs)
            this.$store.dispatch("updateAdmin", itm)
        },
        setSuperAdmin(itm){
            itm.isSupper = !itm.isSupper
            console.log(itm)
           this.$store.dispatch("updateAdmin", itm)
             
        }
    },
    firestore:{
        admins: fb.collection("admins")
    }
}
</script>